/**
 * The services that have a sync screen on Settings > Data Sync, in the order
 * their cards are drawn. Each card opens /settings/sync/<id>.
 */
export const syncServiceIds = [
  "hubspot",
  "salesforce",
  "stripe",
  "woocommerce",
  "shopify",
  "thrivecart",
] as const;
export type SyncServiceId = typeof syncServiceIds[number];

export const DATA_SYNC_PATH = "/settings/sync";

export const syncServicePath = (serviceId: SyncServiceId): string =>
  `${DATA_SYNC_PATH}/${serviceId}`;

/**
 * The paths that show the Data Sync page. The routes use this list, and so does
 * a spec, so the link the connect flow's Done tab makes for Salesforce
 * (/settings/sync/salesforce) cannot lose its route again.
 */
export const dataSyncPaths = [
  DATA_SYNC_PATH,
  ...syncServiceIds.map(syncServicePath),
];

/** The service a Data Sync address is for, or undefined for the page of cards. */
export const syncServiceIdOf = (
  pathname: string
): SyncServiceId | undefined => {
  const found = /^\/settings\/sync\/([^/]+)\/?$/.exec(pathname);
  return syncServiceIds.find((serviceId) => serviceId === (found && found[1]));
};
